import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { ref, reactive } from 'vue'
import { useAsyncTask } from 'vue-concurrency'
import api from '@/estimate/api'
import { Info } from '@/estimate/models'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const infoList = ref<Info[]>([])

/** ページネーションデータ */
const pagination = reactive({
  sortBy: 'infoDt', // 初期ソートカラム
  descending: true, // 初期ソート順 降順=true 昇順=false
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 0,
})

/** 廃車買い取り実績一覧取得タスク */
const getRecordTask = useAsyncTask(async (signal, query) => {
  return api.info.list({ ...query }).then(res => {
    infoList.value = res.infoList
    Object.assign(pagination, res.pagination)
  })
})

getRecordTask.perform({ pagination })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.$style.heading)
    }, "お知らせ", 2),
    _createElementVNode("ol", {
      class: _normalizeClass(_ctx.$style.list)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoList.value, ({ infoDt, infoSubject }) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(_ctx.$style.item),
          key: `news_${infoSubject}`
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.date)
          }, _toDisplayString(infoDt), 3),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.title)
          }, _toDisplayString(infoSubject), 3)
        ], 2))
      }), 128))
    ], 2)
  ], 2))
}
}

})